import { useTranslation } from 'react-i18next';
import carImg from '~/assets/landing/car.jpg';
import bonusImg from '~/assets/landing/bonus.jpg';
import brandImg from '~/assets/landing/brand.jpg';
import bizImg from '~/assets/landing/biz.jpg';
import gadgetsImg from '~/assets/landing/gadgets.jpg';

/**
 * Модалки категорий в блоке «Какие подарки можешь выиграть» (add-promo-landing) — пока демо-тексты макета.
 * Тексты — в каталоге переводов `prizes-ui` (правило i18n: названия и описания призов
 * помечаются к переводу). Картинки — не текст, остаются кодом. Поле лотереи берёт призы
 * из розыгрыша (connect-landing-draw), не отсюда.
 */

export const PRIZE_MODAL_IMAGES = {
  car: carImg,
  tech: gadgetsImg,
  bonus: bonusImg,
  brand: brandImg,
  biz: bizImg,
} as const;

export type PrizeModalKey = keyof typeof PRIZE_MODAL_IMAGES;

export interface PrizeModalGroup {
  heading: string;
  description: string;
  items: { name: string; note: string; qty: number }[];
}

export interface PrizeModalData {
  title: string;
  descriptionHtml: string;
  note?: string;
  groups?: PrizeModalGroup[];
}

/** Содержимое модалок всех категорий призов (клик по карточке в блоке «Какие подарки можешь выиграть»).
 *  Читаем весь объект разом и индексируем обычным JS — динамический ключ внутри `t()` не проходит
 *  строгую типизацию i18next (CustomTypeOptions знает только литеральные пути). */
export function usePrizeModals(): Record<PrizeModalKey, PrizeModalData> {
  const { t } = useTranslation('prizes-ui');
  return t('modals', { returnObjects: true }) as Record<PrizeModalKey, PrizeModalData>;
}
